import type { MeResource as Model } from '@helm/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedMe = Model

export default class MeResource implements CamelCaseKeys<SerializedMe> {
    id!: Model['id']

    name!: Model['name']

    nickname!: Model['nickname']

    bot!: Model['bot']

    email!: Model['email']

    avatar!: Model['avatar']

    permissions!: Model['permissions']

    hasCommandCenter!: Model['hasCommandCenter']

    constructor(values: MeResource) {
        Object.assign(this, values)
    }
}
